module.exports = __webpack_public_path__ + "img/hr-H-B-1-unload-connect-shadow.213da052.png";